

















import { Vue } from 'vue-property-decorator';

export default class CommonForm extends Vue {}

